/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'surface': {
    width: 18,
    height: 18,
    viewBox: '0 0 18 18',
    data: '<g _fill="#FFF" fill-rule="evenodd"><path pid="0" d="M5.25.75V.375A.374.374 0 004.875 0h-3A.374.374 0 001.5.375V.75h3.75zM12 12.75H5.25V6H1.5v10.125c0 .207.167.375.375.375H12v-3.75zM17.625 12.75h-.375v3.75h.375a.375.375 0 00.375-.375v-3a.375.375 0 00-.375-.375"/><path pid="1" d="M16.125 1.5H.375A.374.374 0 000 1.875v3c0 .207.167.375.375.375H12.75v12.375c0 .207.168.375.375.375h3a.375.375 0 00.375-.375V1.875a.374.374 0 00-.375-.375"/><path pid="2" d="M13.125 13.5a.374.374 0 01-.265-.11L4.61 5.14a.374.374 0 010-.53.374.374 0 01.53 0l8.25 8.25a.375.375 0 01-.265.64"/></g>'
  }
})
